import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id C9C3F657-65A6-418E-91EF-E6FD8F0357C1
 * name tape-measure
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tape-measure.svg
 * tags
 * - Hardware / Tools 
 */
export const TapeMeasureIcon = createSvgIcon(<><path d="M9,5A7,7 0 0,1 16,12H17V15H16V19H9A7,7 0 0,1 2,12A7,7 0 0,1 9,5M9,8A4,4 0 0,0 5,12A4,4 0 0,0 9,16A4,4 0 0,0 13,12A4,4 0 0,0 9,8M17,17H22V19L22,21H20V19H17V17Z" /></>, 'TapeMeasureIcon');
export default TapeMeasureIcon